import React from 'react';
import { useThrottledToast } from '../../hooks/useThrottledToast';

import { Switch, PageHeader } from '../../shared/ui';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { selectQuestion } from '../../store/psyTools.slice';
import { selectUser, setUserData } from '../../store/auth.slice';
import { useChangeUserMutation } from '../../services/users.api';
import { useTariffToolCheck } from '../../hooks/useTariffToolCheck';

const Question = () => {
  const tool = 'new_question';
  const isActiveByTariff = useTariffToolCheck(tool);
  const dispatch = useAppDispatch();
  const userData = useAppSelector(selectUser);
  const questions = useAppSelector(selectQuestion);
  const [changeUser] = useChangeUserMutation();
  const showToast = useThrottledToast();

  const handleCheck = async () => {
    try {
      if (!isActiveByTariff) return;
      if (!userData) return;
      if (userData?.active_psy_tools?.includes(tool)) {
        const arr = userData?.active_psy_tools.filter((el) => el !== tool);
        dispatch(setUserData({ ...userData, active_psy_tools: arr }));
        await changeUser({
          id: userData.id,
          active_psy_tools: arr,
        });
      } else {
        dispatch(
          setUserData({
            ...userData,
            active_psy_tools: [...userData?.active_psy_tools, tool],
          }),
        );
        await changeUser({
          id: userData.id,
          active_psy_tools: [...userData?.active_psy_tools, tool],
        });
      }
      showToast('success');
    } catch (error) {
      showToast('error');
    }
  };

  return (
    <div className="pb-[85px]">
      <PageHeader backTo="/tools" title="«Подкинь вопрос» - шпаргалка для психолога" />
      <p className="text-ui text-ink-muted mb-5">
        Универсальные вопросы, на все случаи жизни, направят терапевтическую беседу на более глубокий уровень
        самопознания и размышлений. В случайном порядке, выпавший вопрос можно перефразировать, адаптировать к теме
        беседы или заменить на более подходящий, неограниченное количество раз.
      </p>
      <div className="flex items-center gap-5 mb-[40px]">
        <Switch
          disabled={!isActiveByTariff}
          checked={userData?.active_psy_tools?.includes(tool)}
          onChange={() => handleCheck()}
          label={'Использовать Подкинь вопрос в видео-сессииях'}
        />
      </div>

      <div className="font-medium text-ink mb-[10px]">Список вопросов</div>
      <ul className="list-disc pl-[30px] text-ui text-ink-muted">
        {questions && questions.psy_tool_settings[0].value.map((question) => <li key={question}>{question}</li>)}
      </ul>
    </div>
  );
};

export default Question;
